import "./modalFooterLoader.scss";

import PropTypes from "prop-types";
import React from "react";
import Loader from "react-loaders";

const colors = {
  Light: "#333333",
  Dark: "#FFFFFF",
  AeonBlue: "#FFFFFF",
  HighContrastLight: "#000000",
  HighContrastDark: "#FFFFFF",
  Mellow: "#333333"
};

const ModalFooterLoader = props => {
  return (
    <span className="modalFooterLoader">
      <Loader type="ball-pulse" active={props.visible} color={colors[props.skin]} />
    </span>
  );
};

ModalFooterLoader.propTypes = {
  visible: PropTypes.bool,
  skin: PropTypes.string
};

export default ModalFooterLoader;
